import React, { Component } from "react";
import { checkConditionGroup, checkTranslation, conditionalWidth, imageAddress, sizeConvertor, textVariableReplacer, translate } from "../../../utils/useful";
import IconMap from "../IconMap";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
// import SettingsViewer from '../../components/SettingsViewer';
import { saveAs } from "file-saver";
import ButtonAnimated from "../../../components/buttons/ButtonAnimated";
import Modal from "../../../components/Modal";
import FormViewer from "../../../components/FormViewer";

class PropertiesView extends Component {
    state = {
        members: [
            { img: '/assets/profile-def.png' },
            { img: '/assets/profile-def.png' },
            { img: '/assets/profile-def.png' },
            { img: '/assets/profile-def.png' },
        ],
        detail: true,
        activity: false,
        headers: [
            { key: 'hubs', type: 'GlobalUserMultiInput', col: '12', information: { label: '{{lang}}users', address: 'searchHubs', fields: { title: 'username', value: '_id', image: 'image' }, filter: { applet: '{{appletId}}', appletHub: '{{appletHub}}' }, type: 'api', isSearchable: false, placeholder: '{{lang}}Select', required: true } },
        ],
        imageExtentions: ['png', 'jpg', 'jpeg', 'svg', 'gif'],
        videoExtentions: ['mp4'],

        featuredActions: ['preview', 'download', 'copyLink'],

        accessTypes: [
            { key: 'frameAccess', title: '{{lang}}Frame access ', access: '{{lang}}can view', icon: '/assets/icons/useful/key-access.png', description: 'Access will be limited based on the frame permissions and access.' },
            { key: 'frameAndExtra', title: '{{lang}}Frame access + extra access', access: '{{lang}}can view', icon: '/assets/icons/useful/people.png', description: 'Access will be limited based on the frame permissions and some extra specific hubs, people, and/or groups.' },
            { key: 'restricted', title: '{{lang}}Restricted ', access: '', icon: '/assets/icons/useful/people.png', description: "Only specific hubs and/or groups can have access." },
            { key: 'link', title: '{{lang}}Anyone with link ', access: '', icon: '/assets/icons/useful/link.png', description: "Anyone with link can have access." },
        ],

    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {

        if (this.props.currentItem != prevProps.currentItem) {
            this.init()
        }
    }

    init() {

        if (this.props.currentItem) {


            let accessTypes = this.state.accessTypes
            let access
            // console.log(this.props.currentItem)
            if (this.props.currentItem?.access && typeof this.props.currentItem?.access == 'string') {
                accessTypes.forEach(element => {
                    if (element.key == this.props.currentItem?.access) {
                        access = element
                    }
                })
            }

            if (!access) {
                access = accessTypes[0]
            }


            let list = []
            if (access.key == 'frameAndExtra' || access.key == 'restricted') {
                
                let allowed = this.props.currentItem?.allowed

                if (allowed && (allowed?.hubs?.length > 0 || allowed?.groups?.length > 0)) {
                    if (allowed?.hubs?.length > 0) {
                        for (let i = 0; i < allowed?.hubs.length; i++) {
                            const hub = allowed?.hubs[i]?.hub;
                            list.push({ _id: hub._id, name: hub.fullname, username: hub.username, image: hub.image, type: 'hub' })
                        }
                    }

                    if (allowed?.groups?.length > 0) {
                        for (let i = 0; i < allowed?.groups.length; i++) {
                            const group = allowed?.groups[i]?.group;
                            list.push({ _id: group._id, name: group.name, image: group.image, type: 'group' })
                        }
                    }
                }
            }
            // console.log(access, list)
            this.setState({ accessType: access, allowedList: list })


        }
    }



    changeActive = () => {
        let { detail, activity } = this.state
        this.setState({ detail: !detail, activity: !activity })
    }


    downloadFile = (fullData, extra, info) => {
        let file = 'test.png'
        let data = textVariableReplacer(fullData, fullData.address, '', 'downloaaaad')
        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }
        // console.log('downloading...',data)
        saveAs(imageAddress(data))
    }

    manageAccess = () => {
        this.props.openShareModal()
    }

    openPreview = () => {
        this.props.functionsHandler('frame', 'openPreview', this.props.currentItem)
    }

    setAccess = () => {

    }

    handleAllowed = () => {

        // let names = `Owned by ${this.props.currentItem?.creator?._id == this.props.user.info?._id ? 'you' : this.props.currentItem?.creator?.fullname}. Shared with `
        // let list = []
        // let allowed = this.props.currentItem?.allowed

        if (this.state.allowedList?.length > 0) {

            return <div className="flexc mt-3">
                {this.state.allowedList.map((item, index) => {
                    return (
                        <div key={item._id} className="" style={{ marginLeft: index > 0 ? -8 : 0 }}>
                            <img className="br-20" src={imageAddress(item.image, item.type, 'mini')} height={30} width={30} style={{ objectFit: 'cover', border: '1px solid #eee' }} alt="" />
                        </div>
                    )
                })}
            </div>
        }
    }

    handleCopy = (item) => {
        navigator.clipboard.writeText(item);
        this.props.actions.addNotif({ type: 'success', title: 'Successfuly Copied!', description: 'Information Successfuly Copied.' })
    }

    actionClicked = (prop, extra) => {

        let myExtra = extra
        if (typeof extra == 'object') {
            myExtra = extra ? { ...extra } : {}
            // myExtra.index = this.selectedRowIndex
        }
        this.props.functionsHandler('frame', prop.function, this.props.currentItem, myExtra)

    }


    render() {
        let language = this.props.language
        let colors = this.props.colors
        return (
            <div className="h-100 bg-white position-relative">
                <div className=" h-100 scroll-no-scrollbar pb-5">




                    {/* {this.props.currentItem?.type === 'file' &&
                        <div className='py-2' style={{}}>
                            {console.log('this.props.currentItem?.address2',this.props.currentItem?.address)}
                            <div className=''>
                                <div className="flexcc p-2 mrd-3 br-10" style={{ backgroundColor: '#DDCFE6', width: 30, height: 30 }}>
                                    <img src="/assets/icons/drive/file-white.svg" style={{}} width={50} />
                                </div>
                                <div className="mt-1" style={{}}>
                                    <p className='font-size-12' style={{ color: '#222', }}>{this.props.currentItem?.name}<span className=' font-size-14 ' style={{ color: '#999' }}>{this.props.currentItem?.extension && '.' + this.props.currentItem?.extension}</span></p>
                                </div>
                            </div>
                        </div>
                    } */}
                    <div className="w-100 pt-2 top-0" style={{ position: 'sticky', background: "#fff", zIndex: 1, borderBottom: '1px solid #eee' }}>

                        <div className="flexcb px-2 py-1">
                            <div className="flexc w-100  ">
                                <div className="" style={{}}>
                                    <img className="flexcc" width={30} src={IconMap[this.props.currentItem?.extension?.toLowerCase() ?? this.props.currentItem?.type] ?? '/assets/icons/applets/drive/unknown.png'} alt="" draggable={false} style={{}} />
                                </div>
                                <p className='font-size-14 text-semibold mld-2' style={{ color: '#222', wordBreak: 'break-word' }}>{this.props.currentItem?.name}<span >{this.props.currentItem?.extension && '.' + this.props.currentItem?.extension}</span></p>
                            </div>

                            <div className="mld-2">
                                <button className="flexcc br-20 p-1" style={{}} onClick={() => this.props.close()}>
                                    <img className="opacity-5" src="/assets/icons/useful/x-mark.png" height={20} width={20} alt="" />
                                </button>
                            </div>
                        </div>


                        <div className=" hs-40 flexcc w-100" >
                            <button className='w-100 h-100 flexc px-2 activeButton py-2 mrd-1' onClick={() => this.changeActive()} style={{ borderBottom: this.state.detail ? (colors ? `2px solid ${colors.primaryColor}` : '2px solid #ff8500') : '2px solid transparent', color: this.state.detail ? (colors ? colors.primaryColor : '#FFA01C') : '#777' }}>
                                <p className="font-size-15 weight-600">{translate('drives.Details')}</p>
                            </button>
                            <button className='w-100 h-100 flexc px-2 activeButton py-2 mld-1' onClick={() => this.changeActive()} style={{ borderBottom: this.state.activity ? (colors ? `2px solid ${colors.primaryColor}` : '2px solid #ff8500') : '2px solid transparent', color: this.state.activity ? (colors ? colors.primaryColor : '#FFA01C') : '#777' }}>
                                <p className="font-size-15 weight-600">{translate('drives.Activity')}</p>
                            </button>
                        </div>
                    </div>
                    {this.state.detail &&
                        <div className='mb-3 px-3 pt-2'>
                            {/* {this.state.activity && */}
                            <div className=" ">
                                {this.props.currentItem?.type === 'file' && (
                                    <>

                                        {/* <div className="flexc w-100 px-0">
                                            <div className="br-10 p-2" style={{ backgroundColor: '#eee' }}>
                                                <img className="flexcc" width={30} src={IconMap[this.props.currentItem?.extension] ? IconMap[this.props.currentItem?.extension] : imageAddress(this.props.currentItem?.address)} alt="" draggable={false} style={{}} />
                                            </div>
                                            <p className='font-size-12 mld-2' style={{ color: '#222', }}>{this.props.currentItem?.name}<span >{this.props.currentItem?.extension && '.' + this.props.currentItem?.extension}</span></p>
                                        </div> */}

                                        {/* (!IconMap[this.props.currentItem?.extension] ?
                                        (
                                        <div className="w-100 flexcc px-3" style={{}}>
                                            <img className="w-100 br-10" src={imageAddress(this.props.currentItem?.address)} alt="" />
                                        </div>
                                        ) */}

                                        {this.state.imageExtentions.includes(this.props.currentItem?.extension?.toLowerCase()) && (
                                            <button className="w-100 flexcc br-10 mb-1 mt-2" style={{ border: '1px solid #eee' }} onClick={() => this.openPreview()}>
                                                <img className="w-100 br-10" src={imageAddress(this.props.currentItem?.address, 'image', 'medium')} alt="" style={{ maxHeight: 150, objectFit: 'contain' }} />
                                            </button>
                                        )}


                                        {this.props.currentItem?.extension?.toLowerCase() == 'mp4' && (
                                            <div className="w-100 flexcc br-10 mb-1 mt-2 position-relative" style={{ border: '1px solid #eee' }}>

                                                <img className="w-100 br-10" src={imageAddress(this.props.currentItem?.cover, 'videoCover', 'medium')} alt="" style={{ maxHeight: 150, objectFit: 'cover' }} />

                                                <button className="position-absolute top-0 w-100 h-100 left-0 flexcc" onClick={() => this.openPreview()}>
                                                    <div className="br-30 p-2 flexcc " style={{ background: '#00000080', height: 60, width: 60 }}>
                                                        <img className="invert mld-1" src="/assets/icons/useful/play.svg" height={30} width={30} alt="" />
                                                    </div>

                                                </button>
                                                {/* <video width="100%" height="auto" className='br-10' controls={true} poster={imageAddress(this.props.currentItem?.cover, 'videoCover', 'small')} style={{ maxHeight: 150, objectFit: 'cover' }}>
                                                    <source src={imageAddress(this.props.currentItem?.address)} type="video/mp4" />
                                                </video> */}
                                            </div>
                                        )}

                                    </>
                                )}
                                {/* <div className='position-relative mt-3'>
                                    <div className='text-start br-10 w-100 flexcb' style={{ border: '1px solid #eee' }}>
                                        <p className='font-size-14 flexc w-100 px-3 py-3' style={{ color: "#444" }}>{this.props.currentItem?.link}</p>
                                        <button className='mrd-3' onClick={() => { this.handleCopy(this.props.currentItem?.link) }}>
                                            <img width={22} className='curser-pointer flexcc' src='/assets/icons/copy-black.svg' />
                                        </button>
                                    </div>
                                    <div className='br-10 position-absolute' style={{ backgroundColor: "#fff", width: "max-content", top: -7, left: 8 }}>
                                        <p className='font-size-10 weight-300 px-2' style={{ color: "#777" }} >{translate('drives.Link')}</p>
                                    </div>
                                </div> */}
                                {/* {console.log('aaaaaaaaaa31', this.props.adminView)} */}
                                {(!this.props.isApplet || this.props.adminView) &&
                                    <div className='pt-2 pb-2'>

                                        <div>

                                            <p className='flex-1 text-normal text-semibold mb-2'>{translate('Access and privileges')}</p>
                                            {/* <div className="flexc">
                                            <div className="flexc prd-3" style={{}}>
                                                <img src={imageAddress(this.props.currentItem?.creator?.image, 'profile')} style={{ borderRadius: '100px' }} width={35} alt="" />
                                            </div>
                                            <div style={{ backgroundColor: '#777', width: 1, height: 40 }}></div>
                                            <div className="d-flex flex-row pld-3">

                                                {this.props.currentItem?.allowed?.map((item, index) => {
                                                    return (
                                                        <div className="flexcc prd-1" style={{ borderRadius: '100px', zIndex: 10 }}>
                                                            <img src={imageAddress(item?.image, 'profile')} style={{ borderRadius: '100px' }} width={35} />
                                                        </div>
                                                    )
                                                })}
                                               
                                            </div>
                                        </div> */}
                                            <div className="flexc">
                                                <img className="flexcc mrd-2" width={18} src={this.state.accessType?.icon} alt="" />
                                                <p className="font-size-14 weight-500 ">{checkTranslation(this.state.accessType?.title)}</p>
                                            </div>
                                            <p className="font-size-12 mt-1 ">{translate(this.state.accessType?.description)}</p>
                                            {this.handleAllowed()}

                                            <div className="mt-3">
                                                <ButtonAnimated
                                                    iconwidth='24px'
                                                    onClick={this.manageAccess}
                                                    title={translate('Manage access')}
                                                    icon='/assets/icons/arrow-right-white.svg'
                                                    textColor={this.props.colors?.textColor}
                                                    invert={this.props.colors?.iconInvert}
                                                    bg={this.props.colors ? `linear-gradient(90deg, ${this.props.colors.primaryColor ?? '#FFA01C'}, ${this.props.colors.secondaryColor ?? '#F0C000'})` : `linear-gradient(90deg, #FFA01C, '#F0C000')`}
                                                />
                                            </div>

                                        </div>


                                        <div className="flexc w-100  py-2 mt-3" style={{ borderTop: '1px solid #f0f0f0' }}>

                                            {this.state.featuredActions.map((action, index) => {
                                                let refAction = this.props.dynamicActions[action]
                                                if (refAction) {
                                                    let canShow = true
                                                    if (refAction?.conditions) {
                                                        canShow = checkConditionGroup(refAction.conditions, { data: this.props.currentItem })
                                                        // console.log(refAction)
                                                        // console.log(this.props.currentItem)
                                                        // console.log(canShow)

                                                    }
                                                    if (canShow) {
                                                        return (
                                                            <button className="flexcc flex-column mrd-3" onClick={() => this.actionClicked(refAction)}>

                                                                <div className='br-50  flexcc shadow-drive' style={{ width: 40, height: 40, background: this.props.colors ? this.props.colors.background : '#6B00B6' }} >
                                                                    <img className="flexcc invert" width={18} src={refAction.icon} alt="" />
                                                                </div>
                                                                <p className="text-smallest mt-1 text-semibold">{translate(refAction.label)}</p>

                                                            </button>
                                                        )
                                                    }
                                                }
                                            })}
                                            {/* <button className="flexcc flex-column" onClick={() => { this.openPreview() }}>
                                                <div className='br-50 flexcc shadow-drive' style={{ width: 40, height: 40, background: this.props.colors ? this.props.colors.background : '#6B00B6' }} >
                                                    <img className="flexcc invert" width={20} src="/assets/icons/useful/vision-target (1).svg" alt="" />
                                                </div>
                                                <p className="text-smallest mt-1 text-semibold">{translate("Preview")}</p>
                                            </button>

                                            <button className="flexcc flex-column mld-3" onClick={() => this.downloadFile(this.props.currentItem)}>

                                                <div className='br-50  flexcc shadow-drive' style={{ width: 40, height: 40, background: this.props.colors ? this.props.colors.background : '#6B00B6' }} >
                                                    <img className="flexcc" width={26} src="/assets/icons/drive/dl-white.svg" alt="" />
                                                </div>
                                                <p className="text-smallest mt-1 text-semibold">{translate("Download")}</p>

                                            </button>

                                            <button className="flexcc flex-column mld-3" onClick={() => this.props.shareModal()}>

                                                <div className='br-50  flexcc shadow-drive' style={{ width: 40, height: 40, background: this.props.colors ? this.props.colors.background : '#6B00B6' }} >
                                                    <img className="flexcc invert" width={20} src="/assets/icons/useful/link-alt.svg" alt="" />
                                                </div>
                                                <p className="text-smallest mt-1 text-semibold">{translate("Copy link")}</p>

                                            </button> */}
                                        </div>

                                    </div>
                                }
                                {/* {this.props.currentItem?.type === 'file' &&
                                    <div className='pt-3 pb-2'>
                                        <p className='flex-1 text-normal text-semibold mb-2'>{translate('drives.File owner')}</p>
                                        <div className="">
                                            <img src="/assets/profile-def.png" style={{ borderRadius: '100px' }} width={35} />
                                        </div>
                                    </div>
                                } */}
                            </div>
                            {/* } */}
                            {/* {this.state.detail && */}
                            <div className="">
                                <div className=''>
                                    <p className='flex-1 font-size-16 text-semibold'>{translate('Information')}</p>
                                </div>
                                <div className='mt-3'>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Name')}</p>
                                        <p className='flex-3 text-smaller pld-2' style={{ overflowWrap: 'break-word', whiteSpace: 'pre-wrap', wordBreak: 'break-all', }}>{this.props.currentItem?.type === 'folder' ? this.props.currentItem?.name : this.props.currentItem?.name + '.' + this.props.currentItem?.extension}</p>
                                    </div>
                                </div>
                                <div className='mt-2'>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Type')}</p>
                                        <p className='flex-3 text-smaller pld-2'>{this.props.currentItem?.type === 'folder' ? translate('Folder') : translate('File')}</p>
                                    </div>
                                </div>
                                <div className='mt-2'>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Location')}</p>
                                        <p className='flex-3 text-smaller pld-2'>
                                            <div className="flexcc" style={{ justifyContent: 'left' }}>{
                                                this.props.paths.map((path, index) => {
                                                    return (
                                                        <div className="flexcc">
                                                            <p>{path.name}</p>
                                                            {
                                                                (index !== this.props.paths?.length - 1) &&
                                                                <div className="flexcc text-smaller"
                                                                > {">"} </div>
                                                            }
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </p>
                                    </div>
                                </div>
                                <div className='mt-2' style={{ display: this.props.currentItem?.type === 'folder' && 'none' }}>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Size')}</p>
                                        <p className='flex-3 text-smaller pld-2'>{sizeConvertor(this.props.currentItem?.size)}</p>
                                    </div>
                                </div>
                                <div className='mt-2' style={{ display: this.props.currentItem?.type === 'folder' && 'none' }}>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Extention')}</p>
                                        <p className='flex-3 text-smaller pld-2'>{this.props.currentItem?.extension}</p>
                                    </div>
                                </div>
                                {/* <div className='mt-2' style={{ display: this.props.currentItem?.type === 'file' && 'none' }}>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Contains')}</p>
                                        <p className='flex-3 text-smaller pld-2'>x Files, x Folders</p>
                                    </div>
                                </div> */}
                                <div className='mt-2'>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('Created by')}</p>
                                        <div className="flexc flex-3 text-smaller pld-2">
                                            <div className="flexcc">
                                                <img className="br-20" src={imageAddress(this.props.currentItem?.creator?.image, 'hub', 'thumb')} height={24} alt="" />
                                            </div>
                                            <p className=' text-smaller pld-2'>  {this.props.currentItem?.creator?.fullname}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='mt-2'>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Created')}</p>
                                        <p className='flex-3 text-smaller pld-2'>
                                            {new Date(this.props.currentItem?.cDate).toLocaleString("en-US", {
                                                month: 'numeric',
                                                day: "2-digit",
                                                year: "numeric",
                                                hour: 'numeric', hour12: true,
                                                minute: 'numeric',
                                                second: 'numeric'
                                            })}
                                        </p>
                                    </div>
                                </div>

                                {this.props.currentItem?.lastModifier && (
                                    <div className='mt-2'>
                                        <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                            <p className='flex-1 text-smaller main-c7'>{translate('Created by')}</p>
                                            <div className="flexc flex-3 text-smaller pld-2">
                                                <div className="flexcc">
                                                    <img className="br-20" src={imageAddress(this.props.currentItem?.lastModifier.image, 'hub', 'thumb')} height={24} alt="" />
                                                </div>
                                                <p className=' text-smaller pld-2'>  {this.props.currentItem?.lastModifier?.fullname}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className='mt-2'>
                                    <div className='flexc pb-2' style={{ borderBottom: '1px solid #f6f6f6' }}>
                                        <p className='flex-1 text-smaller main-c7'>{translate('drives.Modified')}</p>
                                        <p className='flex-3 text-smaller pld-2 '>
                                            {new Date(this.props.currentItem?.uDate).toLocaleString("en-US", {
                                                month: 'numeric',
                                                day: "2-digit",
                                                year: "numeric",
                                                hour: 'numeric', hour12: true,
                                                minute: 'numeric',
                                                second: 'numeric'
                                            })}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* } */}
                        </div>
                    }
                    {this.state.activity &&
                        <div className="px-2 py-4 text-center">
                            <p className="text-semibold">{translate("No history records yet")}</p>
                        </div>
                    }
                </div>

                <Modal maxWidth={400} className="" ref={el => this.manageAccessModal = el}>
                    <div className='d-flex w-100 h-100 window-content-radius flexcc'>
                        <div className="manageAccessModal w-100 py-3" style={{}}>
                            <div className="flexcc px-3 pb-3" style={{ justifyContent: 'flex-start' }}>
                                <p className="text-normal  mt-1" style={{ color: '#222' }}>{translate('drives.Manage access')}</p>
                            </div>
                            <FormViewer ref={el => this.form = el} liveChange={this.liveChange} headers={this.state?.headers} formClass="modern" inputClass={'modern-input'} />
                            <div className="flexcb px-3" style={{ justifyContent: 'center' }}>
                                <div className="flexc w-100 pt-2" style={{ justifyContent: 'flex-end' }}>
                                    <div className="flexc mrd-2">
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={() => (this.manageAccessModal.hideModal())}
                                            title={translate('drives.Cancel')}
                                            textColor={'#a3a2b0'}
                                            bg={'#eee'}
                                        />
                                    </div>
                                    <div className="flexc mld-2">
                                        <ButtonAnimated
                                            iconwidth='24px'
                                            onClick={this.setAccess}
                                            title={translate('Done')}
                                            icon='/assets/icons/arrow-right-white.svg'
                                            textColor={this.props.colors?.textColor ?? '#fff'}
                                            invert={this.props.colors?.iconInvert}
                                            bg={this.props.colors ? `linear-gradient(90deg, ${this.props.colors.primaryColor ?? '#FFA01C'}, ${this.props.colors.secondaryColor ?? '#F0C000'})` : `linear-gradient(90deg, #FFA01C, '#F0C000')`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertiesView);